import { render, staticRenderFns } from "./suporte.vue?vue&type=template&id=3de46588&"
import script from "./suporte.vue?vue&type=script&lang=js&"
export * from "./suporte.vue?vue&type=script&lang=js&"
import style0 from "./suporte.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports